import { cn } from "../libs/utils";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./dialog";
import React from "react";

interface CModalProps extends React.HTMLAttributes<HTMLDivElement> {
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
  title: string;
  children: React.ReactNode;
  width?: string;
  className?: string;
}

function CModal({
  isDialogOpen,
  setIsDialogOpen,
  title,
  width,
  className,
  children,
  ...rest
}: CModalProps) {
  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogContent
        className={cn(
          "sm:max-w-[725px] bg-white max-h-[90vh] overflow-y-auto",
          width,
          className
        )}
        {...rest}
      >
        <DialogHeader>
          <DialogTitle className="text-center capitalize text-2xl font-semibold">
            {title}
          </DialogTitle>
        </DialogHeader>

        {children}
      </DialogContent>
    </Dialog>
  );
}

export default CModal;
